module.exports = __webpack_public_path__ + "static/img/grow5_light.acea04d2.png";